<template>
  <div class="weui-pay">
    <template v-if="orderInfo.goods_id != 0">
      <h1 class="weui-payselect-title">您本次消费</h1>
      <p class="weui-pay-num">￥{{orderInfo.price}}</p>
      <ul class="weui-pay-u">
          <li>
              <span class="title">商品名称</span>
              <span class="content">{{orderInfo.freight_name}}</span>
          </li>
          <li>
              <span class="title">数量</span>
              <span class="content">1{{orderInfo.freight_unit}}</span>
          </li>
          <li>
              <span class="title">货道号</span>
              <span class="content">{{orderInfo.No}}</span>
          </li>
          <li>
              <span class="title">货机号</span>
              <span class="content">{{orderInfo.machine_id}}</span>
          </li>
          
      </ul>
    </template>
    <template v-if="orderInfo.goods_id === 0">
      <h1 class="weui-payselect-title">您本次消费</h1>
      <p class="weui-pay-num">￥{{orderInfo.price}}</p>
      <ul class="weui-pay-u">
          <li>
              <span class="title">数量</span>
              <span class="content">1</span>
          </li>
          <li>
              <span class="title">货道号</span>
              <span class="content">{{orderInfo.No}}</span>
          </li>
          <li>
              <span class="title">货机号</span>
              <span class="content">{{orderInfo.machine_id}}</span>
          </li>
          
      </ul>
    </template>
    <div class="pay-div">
        <a href="javascript:;" class="weui-btn weui-btn_primary" @click="handleClick" v-if="showPayBtn">立即支付<span v-if="lock == '1' && freight_way_type == 0">({{t}}s)</span></a>
        <a href="javascript:;" class="weui-btn weui-btn_primary" @click="handleEmployeeClick" v-if="showPayBtn">内部员工支付</span></a>
        <a href="javascript:;" class="weui-btn weui-btn_default" @click="handleClickBack" v-if="show">返回主页</a> 
    </div>
    <template v-if="source == 1">
      <div class="weui-msg__text-area">
        <p  class="weui-msg__desc">请您在支付成功后，等待货机出货，如遇出货问题请根据微信支付凭证，及时联系商家！</p>
      </div>
    </template>
</div>
</template>

<script>
export default {
  name: 'orderPage',
  props:['orderInfo','machineId','show_back','source','showPayBtn','lock','lock_times','freight_way_type'],
  data(){
    return {
      show:true,
      t:60,
    }
  },
  updated(){
     let price = Number(this.orderInfo.price)
     if(price == 0){
        this.showPayBtn = false
     }
  },
  created() {
			if(this.lock == 1){
        this.dec_times()
      }
  },
  computed: {

  },
  methods: {
    handleClick: function(){
      this.$emit('confirm')
    },
    handleClickBack: function(){
      this.$emit("back")
    },
    handleEmployeeClick: function (){
      for(let i=0 ;i < 1000; i++){
				clearInterval(i);
			}
      this.$emit('showEm')
      //console.log('11111')
    },
    dec_times(){
      for(let i=0 ;i < 1000; i++){
				clearInterval(i);
			}
      if(this.lock == '1'){
          var timer = null
          var times = this.lock_times
          var that = this
          timer = setInterval(function(){
            times--;
            that.t = times
            console.log(that.t)
            if (times <=0) {
              clearInterval(timer);
              var info = "您已超时，请退出该页面，重新扫码购买"
              that.$emit("showMessages",info)
              //window.opener=null;
                  //window.close();
            }
          },1000);
      }
    }
  }
}
</script>


<style scoped>
/*支付场景*/
.weui-pay {
    position: relative;
    z-index: 1;
    padding: 15px;
}
.weui-pay-12{
    font-size: 12px;
    font-weight: normal;
}
.weui-pay-inner {
    background-color: #FFFFFF;
    padding: 16px;
    position: relative;
    z-index: 0;
}
.weui-pay-inner:after {
    content: " ";
    width: 200%;
    height: 200%;
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid #DDDDDD;
    transform: scale(0.5);
    transform-origin: 0 0;
    box-sizing: border-box;
}
.weui-pay-title {
    font-size: 18px;
    color: #333333;
    font-weight: normal;
}
.weui-pay-input {
    margin-top: 12px;
    padding-bottom: 18px;
    position: relative;
    z-index: 2;
    color: #333333;
}
.weui-pay-input:after {
    content: " ";
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    height: 1px;
    border-bottom: 1px solid #DDDDDD;
    color: #DDDDDD;
    transform-origin: 0 100%;
    transform: scaleY(0.5);
}
.weui-pay-strong {
    position: absolute;
    color: #000000;
    font-size: 28px;
    line-height: 1;
    left: -6px;
    top: -3px;
    font-weight: normal;
}
.weui-pay-inputs {
    padding-left: 28px;
    width: 100%;
    box-sizing: border-box;
    border: none;
    outline: 0;
    height: 40px;
    line-height: 40px;
    font-size: 40px;
}
.weui-pay-inputs::-webkit-textfield-decoration-container {
    background-color: transparent;
}
.weui-pay-inputs::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
.weui-pay-inputs::-webkit-outer-spin-button {
    -webkit-appearance: none;
}
.weui-pay-inputs::-webkit-input-placeholder {
    color: #EEEEEE;
}
.weui-pay-intro {
    font-size: 12px;
    color: #9e9e9e;
    margin-top: 14px;
}
.weui-pay-info {
    font-size: 12px;
    color: #9e9e9e;
    margin-top: 16px;
    text-align: center;
}
.weui-pay-btn {
    margin-top: 12px;
}
.weui-payselect-title{
    font-size: 17px;
    font-weight: bold;
    text-align: center;
    color: #000000;
}
.weui-payselect-info{
    font-size: 12px;
    color: #a6a4a5;
    text-align: center;
    margin-top: 6px;
}
.weui-payselect-ul{
    margin-top: 28px;
    margin-right: -12px;
    overflow: hidden;
}
.weui-payselect-li{
    float: left;
    list-style-type: none;
    width: 33.33%;
    box-sizing: border-box;
    padding-right: 12px;
    padding-bottom: 12px;
}
.weui-payselect-a{
    display: block;
    border: 1px solid #DADADA;
    color: #dadada;
    height: 38px;
    line-height: 38px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
}
.weui-payselect-on{
    border-color: #07C160;
    color: #07C160;
}
.weui-pay-num{
    font-size: 50px;
    text-align: center;
}
.weui-pay-u li {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-orient: horizontal;
    box-orient: horizontal;
    line-height: 22px;
    width: 100%
}
.weui-pay-u .title {
    font-size: 14px;
    color: #999;
    -webkit-box-flex: 1;
    width: 30%;
    -webkit-flex: 1;
    flex: 1;
    display: block
}
.weui-pay-u .content {
    font-size: 14px;
    color: #333;
    text-align: right;
    -webkit-box-flex: 1;
    width: 70%;
    -webkit-flex: 1;
    flex: 1;
    display: block
}
.weui-pay .pay-div {
    margin: 19px 0 13px 0
}
.weui-payrec {
    position: relative;
    z-index: 1;
}
.weui-payrec .weui_cell_title {
    font-size: 14px;
    line-height: 1.6;
    color: #000000;
}
.weui-payrec .weui_cell_info{
    font-size: 12px;
    line-height: 1.6;
    color: #999;
}
.weui-payrec .access .weui_cell_ft:after {
    content: " ";
    display: inline-block;
    height: 6px;
    width: 6px;
    border-width: 2px 2px 0 0;
    border-color: #C8C8CD;
    border-style: solid;
    -webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
    transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
    position: relative;
    top: -2px;
    position: absolute;
    top: 50%;
    margin-top: -4px;
    right: 2px;
}
.weui-pay-order {background-color:#FFFFFF;margin-bottom:20px;overflow:hidden;padding: 18px 29px 0;}
.weui-pay-m{
    background-color:#FFFFFF;
    margin:0 0 13px;
    padding:0;
    position:relative;
}
.weui-pay-m::before{
    content: '';
    position: absolute;
    top: -50%;
    bottom: -50%;
    left: -50%;
    right: -50%;
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
    border-style: solid;
    border-width: 1px;
    border-color: #EDEDED;

}
.weui-pay-order:before, .weui-pay-order:after{
    content:"";
    background:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAyCAMAAABiSatuAAAAS1BMVEX////j4+P////////t7e3////j4+P////////u7u7g4ODu7u7k5OT8/Pz////////////////////u7u7l5eXf39/s7Ozt7e38/PybHTnUAAAAF3RSTlOv6+mh61D+/ev9r6+vr3jZN0r//////pA5V/oAAACISURBVHja7ZNbDgIhDEUvgMA8Hxba2f9KdTQCpisw8XyeBNqbtlgdOtwKt9lUsZsDbOywAFK8V2L6i6c4KZeS6fwIKpmJOBd5Cw5CLyTwJXygSvDAYrgJNgsmMzQxmAmz74WfMX6LUQn1RH2qyurGdOspyhVOWrgW/8dHqXZdXYO+l/24dRz7A2urJ0UzyblDAAAAAElFTkSuQmCC") repeat-y;
    width:8px;
    height:100%;
    -webkit-background-size:8px 25px;
    background-size:8px 25px;
    position:absolute;
    top:0;
}

.weui-pay-order:before{
    left:8px;
}

.weui-pay-order:after{
    right:8px;
}
.weui-pay-line {
    padding: 0;
    background-color: #FFFFFF;
    position: relative;
    font-size: 16px;
    color: #888888;
}
.weui-pay-line:after{content:"";height:1px;width:100%;left:0;bottom:-1px;position:absolute;display:block;z-index:11;}
.weui-pay-name{
    font-size: 15px;
    color: #333333;
    padding-bottom:5px;
}
.weui-pay-label{
    font-size: 13px;
    overflow: hidden;
    color: #999999;
    width: 72px;
    display:inline-block;
}
.weui-pay-e{
    display:inline-block;
    font-size: 13px;
    color: #333333;
    word-break: break-all;
    word-wrap: break-word;
    padding-right: 15px;
    position: relative;
    overflow: hidden;
}
.weui-pay-area{
    margin-top:7px;
    border-top:0.0625rem dashed #DEDEDE;
}
.weui-pay-area{
    padding:15px 0 14px;
    text-align:center;
    font-size:13px;
    font-weight:700;
    display:-webkit-box;
    display:-webkit-flex;
    display:flex;
    -webkit-box-orient:horizontal;
    box-orient:horizontal;
}

.weui-pay-c{
    color:#999999;
    position:relative;
}
.weui-pay-c,.weui-pay-v{-webkit-box-flex:1;-webkit-flex:1;flex:1;display:block;}
.weui-pay-c:after{
    content:"";
    width:1px;
    height:25px;
    border-left:1px solid #DEDEDE;
    position:absolute;
    top:0;
    right:0;
}

.weui-pay-v{
    color:#07c160;
}



/*按钮*/

.weui-btn{
  position:relative;
  display:block;
  margin-left:auto;
  margin-right:auto;
  padding-left:14px;
  padding-right:14px;
  box-sizing:border-box;
  font-size:18px;
  text-align:center;
  text-decoration:none;
  color:#FFFFFF;
  line-height:2.55555556;
  border-radius:5px;
  -webkit-tap-highlight-color:rgba(0, 0, 0, 0);
  overflow:hidden;
}
.weui-btn:after{
  content:" ";
  width:200%;
  height:200%;
  position:absolute;
  top:0;
  left:0;
  border:1px solid rgba(0, 0, 0, 0.2);
  -webkit-transform:scale(0.5);
          transform:scale(0.5);
  -webkit-transform-origin:0 0;
          transform-origin:0 0;
  box-sizing:border-box;
  border-radius:10px;
}
.weui-btn_inline{
  display:inline-block;
}
.weui-btn_default{
  color:#000000;
  background-color:#F8F8F8;
}
.weui-btn_default:not(.weui-btn_disabled):visited{
  color:#000000;
}
.weui-btn_default:not(.weui-btn_disabled):active{
  color:rgba(0, 0, 0, 0.6);
  background-color:#DEDEDE;
}
.weui-btn_primary{
  background-color:#07c160;
}
.weui-btn_primary:not(.weui-btn_disabled):visited{
  color:#FFFFFF;
}
.weui-btn_primary:not(.weui-btn_disabled):active{
  color:rgba(255, 255, 255, 0.6);
  background-color:#06ad56;
}
.weui-btn_warn{
  background-color:#FA5151;
}
.weui-btn_warn:not(.weui-btn_disabled):visited{
  color:#FFFFFF;
}
.weui-btn_warn:not(.weui-btn_disabled):active{
  color:rgba(255, 255, 255, 0.6);
  background-color:#CE3C39;
}
.weui-btn_disabled{
  color:rgba(255, 255, 255, 0.6);
}
.weui-btn_disabled.weui-btn_default{
  color:rgba(0, 0, 0, 0.3);
  background-color:#F7F7F7;
}
.weui-btn_disabled.weui-btn_primary{
  background-color:#9ED99D;
}
.weui-btn_disabled.weui-btn_warn{
  background-color:#EC8B89;
}
.weui-btn_loading .weui-loading{
  margin:-0.2em 0.34em 0 0;
}
.weui-btn_loading.weui-btn_primary,
.weui-btn_loading.weui-btn_warn{
  color:rgba(255, 255, 255, 0.6);
}
.weui-btn_loading.weui-btn_primary{
  background-color:#06ad56;
}
.weui-btn_loading.weui-btn_warn{
  background-color:#CE3C39;
}
.weui-btn_plain-primary{
  color:#07c160;
  border:1px solid #07c160;
}
.weui-btn_plain-primary:not(.weui-btn_plain-disabled):active{
  color:rgba(26, 173, 25, 0.6);
  border-color:rgba(26, 173, 25, 0.6);
}
.weui-btn_plain-primary:after{
  border-width:0;
}
.weui-btn_plain-default{
  color:#353535;
  border:1px solid #353535;
}
.weui-btn_plain-default:not(.weui-btn_plain-disabled):active{
  color:rgba(53, 53, 53, 0.6);
  border-color:rgba(53, 53, 53, 0.6);
}
.weui-btn_plain-default:after{
  border-width:0;
}
.weui-btn_plain-disabled{
  color:rgba(0, 0, 0, 0.2);
  border-color:rgba(0, 0, 0, 0.2);
}
button.weui-btn,
input.weui-btn{
  width:100%;
  border-width:0;
  outline:0;
  -webkit-appearance:none;
}
button.weui-btn:focus,
input.weui-btn:focus{
  outline:0;
}
button.weui-btn_inline,
input.weui-btn_inline,
button.weui-btn_mini,
input.weui-btn_mini{
  width:auto;
}
button.weui-btn_plain-primary,
input.weui-btn_plain-primary,
button.weui-btn_plain-default,
input.weui-btn_plain-default{
  border-width:1px;
  background-color:transparent;
}
.weui-btn_mini{
  display:inline-block;
  padding:0 1.32em;
  line-height:2.3;
  font-size:13px;
}
.weui-btn + .weui-btn{
  margin-top:15px;
}
.weui-btn.weui-btn_inline + .weui-btn.weui-btn_inline{
  margin-top:auto;
  margin-left:15px;
}
.weui-btn-area{
  margin:1.17647059em 15px 0.3em;
}
.weui-btn-area_inline{
  display:-webkit-box;
  display:-webkit-flex;
  display:flex;
}
.weui-btn-area_inline .weui-btn{
  margin-top:auto;
  margin-right:15px;
  width:100%;
  -webkit-box-flex:1;
  -webkit-flex:1;
          flex:1;
}
.weui-btn-area_inline .weui-btn:last-child{
  margin-right:0;
}


.weui-msg__text-area{
  margin-bottom:25px;
  padding:0 20px;
}
.weui-msg__desc{
  font-size:14px;
  color:#999999;
  word-wrap:break-word;
  word-break:break-all;
}
</style>    


// WEBPACK FOOTER //
// src/components/orderPage/orderPage.vue